import { render, staticRenderFns } from "./IntegrationDetails.vue?vue&type=template&id=1e32e99e&scoped=true&"
import script from "./IntegrationDetails.vue?vue&type=script&lang=js&"
export * from "./IntegrationDetails.vue?vue&type=script&lang=js&"
import style1 from "./IntegrationDetails.vue?vue&type=style&index=1&id=1e32e99e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e32e99e",
  null
  
)

export default component.exports